import React, { Component } from 'react';
import { Modal, Button, Input, message, Upload, Radio, Select, Tooltip } from 'antd';
import $, { xToken } from '../../../common/AjaxRequest';
import API_URL from '../../../common/url';


const RadioGroup = Radio.Group;
const Option = Select.Option;

class UploadFileModal extends Component {
    state = {
        params: {},
        visible: false,
        loading: false,
        fileList: [],
        pathName: '',
        uploadStatus: '',
        uploadId: '',
    }

    show = () => {
        this.setState({
            visible: true,
        });
    }

    hide = () => {
        const { uploadStatus } = this.state;
        if (uploadStatus == 'uploading') {
            Modal.confirm({
                iconType: 'question-circle',
                title: <div style={{ marginLeft: 42 }}>上传尚未完成，要取消文件上传吗？</div>,
                okText: '取消上传',
                cancelText: '继续上传',
                onOk: () => {
                    this.cancelBatchUpload();
                },
            });
        } else {
            this.setState({
                params: {},
                fileList: [],
                involveSites: [],
                visible: false,
                loading: false,
            });
        }
    }

    cancelBatchUpload = () => {
        const { uploadId } = this.state;
        if (!uploadId) return;
        const options = {
            method: 'POST',
            url: API_URL.deptFile.cancelUpload,
            data: {
                uploadId,
            },
            dataType: 'json',
            doneResult: res => {
                message.destroy();
                this.setState({ loading: false, uploadStatus: '' }, () => this.hide());
                message.info('文件上传已取消');
            },
            errorResult: () => {
                
            }
        };
        $.sendRequest(options);
    };

    handleChange = (value, key) => {
        const { params } = this.state;
        params[key] = value;
        this.setState({ params });
    }

    beforeUpload = (file, fileList) => {
        // 检查文件大小，限制为2GB
        const maxSize = 2 * 1024 * 1024 * 1024; // 2GB in bytes
        if (file.size > maxSize) {
            message.error(`单个文件最大支持2GB，无法上传`);
            return false; // 阻止上传
        }

        this.setState({
            fileList: [
                ...this.state.fileList,
                ...fileList,
            ]
        })
        return false
    }

    handleRemove = (file) => {
        const { fileList, uploadStatus } = this.state;
        if (uploadStatus === 'uploading') return message.warning('上传尚未完成，不能删除文件');
        const index = fileList.indexOf(file);
        const newFileList = fileList.slice();
        newFileList.splice(index, 1);
        this.setState({ fileList: newFileList });
    }
    // 新增操作日志
    submitAddFileLog = (data) => {
        const options = {
            method: 'POST',
            url: API_URL.deptFile.addFileLog,
            data,
            dataType: 'json',
            doneResult: res => {
                
            },
            errorResult: () => {
                
            }
        };
        $.sendRequest(options);
    }

    submit = () => {
        const { params, fileList, } = this.state;
        const { catalogId, pathName } = this.props;
        const fileNameList = []
        const {
            version,
        } = params;
        const pathNameArr = pathName.split('-->');
        //校验必填
        if (fileList.length === 0) {
            return message.warning('请选择需要上传的文件')
        }
        if (!version) {
            return message.warning('请输入版本号')
        }

        const fromData = new FormData();
        const uploadId = `${Date.now()}_${sessionStorage.userId}`;
        fileList.map((file, index) => {
            fromData.append(`files[${index}]`, file)
            fileNameList.push(file.name)
        });

        fromData.append('curUserId', sessionStorage.userId);
        fromData.append('curRoleCode', sessionStorage.curRole);
        fromData.append('curEmployeeCode', sessionStorage.curEmployeeCode || '');
        fromData.append('catalogId', catalogId);
        fromData.append('uploadId', uploadId);
        if (version) fromData.append('version', version);
        this.setState({ loading: true });
        message.success('正在上传中...', 9999999);
        this.setState({ uploadStatus: 'uploading', uploadId });
        fetch(API_URL.deptFile.uploadFile, {
            method: 'post',
            body: fromData,
            headers: {
                'X-Requested-With': 'XMLHttpRequest',
                ...xToken,
            }
        }).then(res => {
            if (res.ok) {
                return res.json();
            }
        }).then(data => {
            // 清除message提示
            message.destroy();
            this.setState({ uploadStatus: '' });
            if (data.error) {
                // message.error(data.error);
                this.setState({ loading: false });
            } else {
                message.success(data.success);
                this.hide();
                this.props.queryTableData();
                this.submitAddFileLog({
                    catalogId,
                    curUserId: sessionStorage.userId,
                    operateType: 'UPLOAD_FILE',
                    fileCatalog: pathNameArr.join('->'),
                    operateFile: fileNameList.join(','),
                })
            }
        }).catch(err => {
            message.destroy();
            this.setState({ uploadStatus: '' });
            // message.error(err);
        });
    }

    //判断字段是否等于某些值
    booleanEquals = (key, value = []) => {
        return value.some((el) => key === el);
    };

    render() {
        const { pathName } = this.props;
        const pathNameArr = pathName.split('-->');
        let pathNameshow = pathNameArr.slice(0, 3).join('-->');
        if (pathNameArr.length > 3) {
            pathNameshow += '...';
        }
        const { visible, params, fileList, loading } = this.state;
        const { version } = params;
        const asterisk = <span style={{ color: 'red' }}>*</span>;
        return (
            <Modal
                title={'上传文件'}
                visible={visible}
                onCancel={this.hide}
                onOk={this.submit}
                className="preview-modal"
                maskClosable={false}
                confirmLoading={loading}
                width="500px"
            >
                <div className="modal-content" style={{ padding: '20px 30px' }}>
                    <ul className="modal-list">
                        <li className="modal-item">
                            <div style={{ marginLeft: 40 }}>
                                <Tooltip title={pathName} >
                                    {pathNameshow}
                                </Tooltip>
                            </div>
                        </li>
                        <li className="modal-item">
                            <div className="item-left" style={{ width: '40%' }}>{asterisk}上传附件：</div>
                            <div className="item-right" style={{ width: '60%' }}>
                                <Upload
                                    data={{
                                        curUserId: sessionStorage.userId,
                                        curEmployeeCode: sessionStorage.curEmployeeCode || '',
                                    }}
                                    fileList={fileList}
                                    multiple={true}
                                    beforeUpload={this.beforeUpload}
                                    onRemove={this.handleRemove}
                                    headers={xToken}
                                >
                                    <Button style={{ width: 80 }}>选择文件</Button>
                                </Upload>
                            </div>
                        </li>
                        <li className="modal-item">
                            <div className="item-left" style={{ width: '40%' }}>{asterisk}版本号：</div>
                            <div className="item-right" style={{ width: '60%' }}>
                                <Input
                                    placeholder='请输入'
                                    style={{ width: 160 }}
                                    value={version}
                                    onChange={e => this.handleChange(e.target.value, 'version')}
                                />
                            </div>
                        </li>

                    </ul>
                </div>
            </Modal>
        );
    }
}

export default UploadFileModal;


// WEBPACK FOOTER //
// ./src/components/documentManagement/departmentalDocuments/UploadFileModal.js